import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Card, Text, TextInput, Group, SegmentedControl } from "@mantine/core";

import { PaginatedList } from "@components/shared";

export default function PrizePoolList({
  isIndex = false,
  isManager = false,
  items = null,
  requestInfo = {
    url: `/retrieve-contests/`,
    data: {},
  },
  refresh,
}) {
  const [searchValue, setSearchValue] = useState("");
  const [filters, setFilters] = useState({
    status: "entire",
    owned_by: "true",
  });
  const [refresh2, setRefresh2] = useState(false);

  const reqData = {
    ...filters,
    owned_by: isManager ? true : filters.owned_by === "true" ? true : false,
    ...requestInfo.data,
    search_value: searchValue,
    refresh,
    refresh2,
    variety: 2,
  };

  return (
    <div>
      {requestInfo && (
        <React.Fragment>
          <TextInput
            placeholder="Search..."
            size="lg"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          />
          <Group my="xs">
            <SegmentedControl
              value={filters.status}
              data={[
                { label: "All", value: "entire" },
                { label: "Active", value: "active" },
                { label: "Upcoming", value: "upcoming" },
                { label: "Expired", value: "expired" },
              ]}
              onChange={(e) => setFilters({ ...filters, status: e })}
            />
            <SegmentedControl
              value={filters.owned_by}
              data={[
                { label: "This entity", value: "true" },
                { label: "Someone else", value: "false" },
              ]}
              onChange={(e) => setFilters({ ...filters, owned_by: e })}
            />
          </Group>
        </React.Fragment>
      )}
      <PaginatedList
        tableData={items}
        requestInfo={{
          url: requestInfo.url,
          data: reqData,
        }}
        responseMapping={(r) =>
          r.map((m) => ({
            ...m,
            entity_id: m.organization_id || m.location_id,
            link_url: `/prize-pools/${m.id}`,
          }))
        }
        displayFormatter={(item) => (
          <PrizePoolItem contestInfo={item.original} />
        )}
      />
    </div>
  );
}

const PrizePoolItem = ({ contestInfo }) => {
  return <ContestItem contestInfo={contestInfo} asLink />;
};
